<template>
  <b-modal id="product-details-modal" size="lg" hide-footer v-if="product.id != null" role="document"
           @show="handleShow"
           centered :header-class="{'modal-bg': product.imagePath}">
    <template v-slot:modal-header="{}">
      <div v-if="product.imagePath" class="bg-image"
           :style="{'background-image': 'url(' + getImagePath(product.imagePath, 'modal_background') + ')'}">
        <b-button @click="$bvModal.hide('product-details-modal')" class="close-btn close-dark">
          <span></span>
          <span></span>
        </b-button>
      </div>
    </template>
    <div class="modal-content">
      <div class="modal-body">
        <div class="customize-meta">
          <h4 class="customize-title">
            {{ product.name }}
            <price v-if="selectedProductPrice" :price="selectedProductPrice.gross"
                   class="custom-primary selected-price">
            </price>
          </h4>
          <p>
            {{ product.description }}
          </p>
        </div>
        <div class="customize-variations">
          <div class="customize-size-wrapper">
            <h5 v-if="filteredPrices.length">{{ $t('Size') }}: </h5>
            <div v-for="(productPrice, key) in filteredPrices" :key="key" class="customize-size"
                 @click="selectProductPrice(productPrice)"
                 :class="{active: selectedProductPrice === productPrice }">
              {{ productPrice.size.name }}
            </div>
          </div>

          <div class="row" v-if="product.ingredients.length">
            <!-- Variation Start -->
            <div class="col-lg-12 col-12">
              <h5>{{ $t('Ingredients') }}</h5>
              <div class="customize-variation-wrapper newspaper-two-columns">
                <!--                   <i class="flaticon-pizza-and-cutted-slice"></i> -->
                <div v-for="ingredient in product.ingredients" :key="ingredient.id" class="customize-variation-item">
                  <!--                  <div class="custom-control custom-checkbox">-->
                  <!--                    <input type="checkbox" class="custom-control-input">-->
                  <!--                    <label class="custom-control-label">{{ ingredient.name }}</label>-->
                  <!--                  </div>-->
                  <div>
                    <span class="fa fa-check"></span>
                    {{ ingredient.name }}
                  </div>
                  <!--                    <span>+2.00$</span> -->
                </div>
              </div>
            </div>
            <!-- Variation End -->

          </div>


          <!--                      <div class="customize-controls">-->

          <!--                        <div class="qty">-->
          <!--                           <span class="qty-subtract"><i class="fas fa-minus"></i></span>-->
          <!--                           <input type="text" name="qty" value="1">-->
          <!--                           <span class="qty-add"><i class="fas fa-plus"></i></span>-->

          <!--                        </div>-->


          <!--                        <div class="customize-total" data-price="13.99">-->
          <!--                           <h5>Total Price: <span class="final-price custom-primary">13.99 <span>$</span> </span>-->
          <!--                             </h5>-->

          <!--                        </div>-->


          <!--                      </div>-->


          <div class="row">
            <!-- Variation Start -->
            <div class="col-lg-12 col-12">

              <!--                <button type="button" class="btn-custom btn-block">Order Now</button>-->

              <b-button @click="$bvModal.hide('product-details-modal')" class="btn-custom btn-block"
                        aria-label="Close">{{ $t('Close') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";
import Price from "@/views/partials/Price";
import {BButton, BModal} from 'bootstrap-vue'

export default {
  name: 'RestaurantMenuProduct',
  components: {Price, BButton, BModal},
  mixins: [imageMixin],
  data() {
    return {
      selectedProductPrice: null
    }
  },
  props: {
    product: {
      type: Object,
      default: () => {
        return {id: null}
      }
    }
  },
  methods: {
    handleShow() {
      if (typeof (this.product.productPrices) != 'undefined' && this.product.productPrices.length) {
        this.selectProductPrice(this.product.productPrices[0]);
      }
    },
    handleClose() {
      this.selectProductPrice(null);
      this.product = {id: null};
    },
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice;
    }
  },
  computed: {
    filteredPrices() {
      let self = this;

      return self.product.productPrices.filter(price => {
        if (price.size) {
          return true;
        }
        return false;
      });
    }
  }
}
</script>
